import { useEffect, useState, useContext } from "react";
import { useSelector } from "react-redux";
import { ContactOriginFilters } from "./ContactOriginFilters";
import { ConversationFilters } from "./ConversationFilters";
import { TeamMembersFilters } from "./TeamMembersFilters";
import { TagsFilters } from "./TagsFilters";
import AudienceFilters from "./AudienceFilters";
import { Typography } from "antd";
// API
import {
  crmTeamMembers,
  crmTags,
  addPinnedTags,
  removePinnedTags,
} from "../../api/Api";
import NotificationContext from "../../../../providers/NotificationProvider";
import { showSuccessToast } from "../../../../components/commonComponents/gxAntdToast/toastUtils";

const { Title } = Typography

export const Sidebar = ({ activeFilter, setActiveFilter, className, audienceSets }) => {
  const { currentBrand } = useSelector((state) => state?.app);

  // Feature flags
  const { featureFlags } = useSelector((state) => state.app);
  const isAudienceManagementSystemEnabled = featureFlags?.ams_feature;

  const [teamMembers, setTeamMembers] = useState([]);
  const [tagList, setTagList] = useState([]);
  const notification = useContext(NotificationContext)

  const fetchTeamMembers = () => {
    const brandId = currentBrand.brand_id;
    if (brandId) {
      // setTeamsLoading(true);  
      crmTeamMembers(brandId)
        .then((res) => {
          if (res?.status === 200) {
            setTeamMembers(res?.data?.users);
            // setTeamsLoading(false);
          }
        })
        .finally(() => {
          // setTeamsLoading(false);
        });
    } else {
      setTeamMembers([]);
    }
  };

  const fetchTagList = () => {
    const brandId = currentBrand.brand_id;
    if (brandId) {
      // setTeamsLoading(true);  
      crmTags(brandId)
        .then((res) => {
          if (res?.status === 200) {
            setTagList(res?.data?.user_pin_tags);
            // setTeamsLoading(false);
          }
        })
        .finally(() => {
          // setTeamsLoading(false);
        });
    } else {
      setTagList([]);
    }
  };

  const addTag = (id) => {
    const payLoad = {
      brand_id: currentBrand?.brand_id,
      pinned: true,
      tag_id: id,
    };
    addPinnedTags(payLoad)
        .then((res) => {
          if (res?.status === 200) {
            fetchTagList(currentBrand?.brand_id);
            showSuccessToast(notification, "Tag is pinned successfully")
          }
        })
        .finally(() => {
          // setTeamsLoading(false);
        });
  };

  const removeTag = (id) => {
    const payLoad = {
      brand_id: currentBrand?.brand_id,
      pinned: false,
      tag_id: id,
    };
    
    removePinnedTags(payLoad)
        .then((res) => {
          if (res?.status === 200) {
            fetchTagList(currentBrand?.brand_id);
            showSuccessToast(notification, "Tag is unpinned successfully")
          }
        })
        .finally(() => {
          // setTeamsLoading(false);
        });
  };

  useEffect(() => {
    fetchTeamMembers(currentBrand?.brand_id);
    fetchTagList(currentBrand?.brand_id);
    setActiveFilter(0);
  }, []);

  return (

    <div
      className={` h-full overflow-y-auto bg-white border-r border-r-gray-200 ${className}`}
    >
      <div className="p-4 pb-0 border-b border-gray-200">
        <Title level={4} className="text-gray-700 mb-1">Contacts</Title>
      </div>

      <div className="flex flex-col">
        <ConversationFilters 
          activeFilter={activeFilter}
          setActiveFilter={setActiveFilter}
        />

        {isAudienceManagementSystemEnabled && (
          <AudienceFilters
            activeFilter={activeFilter}
            setActiveFilter={setActiveFilter}
            audienceSets={audienceSets}
          />
        )}

        <ContactOriginFilters
          activeFilter={activeFilter}
          setActiveFilter={setActiveFilter}
        />

        <TeamMembersFilters
          activeFilter={activeFilter}
          setActiveFilter={setActiveFilter}
          teamMembers={teamMembers}
        />

        <TagsFilters
          activeFilter={activeFilter}
          setActiveFilter={setActiveFilter}
          tagList={tagList}
          addTag={addTag}
          removeTag={removeTag}
        />
      </div>
    </div>
  );
};
